<template>
	<div class="Curator-outer-editor">

		<card class="quide-table col-sm-12">
			<el-table :data="tableData">
				<el-table-column
					min-width="130"
					sortable
					label="Застройщик"
				>							
					<template v-slot="scope">
						{{$GVO.GetCat('CAT_DEV',scope.row.dc_dev_name_tr).name}}
					</template>
				</el-table-column>
				<el-table-column
					min-width="130"								
					label="ФИО"
				>
					<template v-slot="scope">
						<base-input
						placeholder="ФИО"
						v-model="scope.row.external_fio"
						autocomplete="off"
						class="mt-2"
						></base-input>
					</template>
				</el-table-column>
				<el-table-column
					min-width="130"								
					label="Тел."
				>
					<template v-slot="scope">
						<base-input
							placeholder="Телефон"
							v-model="scope.row.phone"
							autocomplete="off"
							class="mt-2"
						></base-input>
					</template>
				</el-table-column>
				<el-table-column
					min-width="100"
					label="Telegram"
				>
					<template v-slot="scope">
						<base-checkbox v-model="scope.row.telegram"></base-checkbox>
					</template>
				</el-table-column>
				<el-table-column
					min-width="105"					
					label="WhatsApp"
				>	
					<template v-slot="scope">
						<base-checkbox v-model="scope.row.whatsapp"></base-checkbox>
					</template>
				</el-table-column>
				<el-table-column
					min-width="130"					
					label="e-mail"
				>	
					<template v-slot="scope">
						<base-input
							placeholder="Добавьте почту"
							v-model="scope.row.email"
							autocomplete="off"
							class="mt-2"
						></base-input>
					</template>
				</el-table-column>
				<el-table-column
					min-width="130"					
					label="Сайт"
				>	
					<template v-slot="scope">
						<base-input
							placeholder="Добавьте сайт"
							v-model="scope.row.site"
							autocomplete="off"
							class="mt-2"
						></base-input>
					</template>
				</el-table-column>
				<el-table-column
					min-width="130"					
					label="Агрегатор"
				>	
					<template v-slot="scope">
						<el-select
							class="col-md px-0 select-primary"						
							filterable
							placeholder="Выберите агрегатор"
							v-model="scope.row.agregator_id"
							size="large"
						>
							<el-option
								class="select-primary"
								v-for="option in masAgrOpts"
								:key="option.label"
								:label="option.label"
								:value="option.value"
							>
							</el-option>
						</el-select>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="successMsg" class="success-msg"><h6>Данные успешно сохранены!</h6></div>
			<div class="bottom_part mt-2">
				<base-button type="success" simple @click="Save()">Сохранить</base-button>
			</div>
		</card>
		
	</div>
</template>

<script>
	import { Table, TableColumn } from 'element-ui';
	import { Select, Option } from 'element-ui';
	

	export default {
		name: 'curator-outer-editor-page',
		components: {
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {

		}, 
		
		data() {
			return {
				agrVal:'',
				tableData: [],
				masAgrOpts: [],
				successMsg: false,
    		}
		},

		methods: {
			PrepareTableData(){
				for (let i = 0; i < this.tableData.length; i++) {
					/*
					if(this.tableData[i].min_commission == -1) this.tableData[i].min_commission = '';
					if(this.tableData[i].max_commission == -1) this.tableData[i].max_commission = '';
					if(this.tableData[i].ads == -1) this.tableData[i].ads = '';
					if(this.tableData[i].restriction_ids !== '') this.tableData[i].restriction_ids = this.tableData[i].restriction_ids.split(',');
					*/

					if(this.tableData[i].external_fio == -1) this.tableData[i].external_fio = '';
					if(this.tableData[i].phone == -1) this.tableData[i].phone = '';
					this.tableData[i].telegram=this.tableData[i].telegram==1?true:false;
					//if(this.tableData[i].telegram==1)this.tableData[i].telegram = true; 
					//if(this.tableData[i].telegram==0)this.tableData[i].telegram = false; 
					//if(this.tableData[i].whatsapp==1)this.tableData[i].whatsapp = true; 
					//if(this.tableData[i].whatsapp==0)this.tableData[i].whatsapp = false; 
					this.tableData[i].whatsapp=this.tableData[i].whatsapp==1?true:false;
					if(this.tableData[i].email == -1) this.tableData[i].email = '';
					if(this.tableData[i].site == -1) this.tableData[i].site = '';
					if(this.tableData[i].agregator_id == -1) this.tableData[i].agregator_id = '';
				}
			},
			GetData(){
				this.$GVO.ApiCall('GetMyDevExtraData',{obj:'DEV' ,flt:{}})
				.then((objApi) => {
					if(objApi.success === true){
						// console.log(objApi.data);
						this.$GVO.LoadCatPromise('CAT_DEV',true).then((bCatLoaded) => {
							this.$GVO.LoadCatPromise('CAT_AGREGATORS',true).then((bCatLoaded) => {
								this.masAgrOpts = this.$GVO.getCatToSelect('CAT_AGREGATORS');
								this.tableData = objApi.data;
								this.PrepareTableData();
							}).catch(errorObjApi => {console.error(errorObjApi);});
						}).catch(errorObjApi => {console.error(errorObjApi);});
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});
			},
			Save(){
				for (let i = 0; i < this.tableData.length; i++) {
					/*
					this.tableData[i].restriction_names = [];
					if(this.tableData[i].min_commission == '') this.tableData[i].min_commission = null;
					if(this.tableData[i].max_commission == '') this.tableData[i].max_commission = null;
					if(this.tableData[i].ads == '') this.tableData[i].ads = null;

					if(this.tableData[i].restriction_ids != null){
						for (let y = 0; y < this.tableData[i].restriction_ids.length; y++) {
							const element = this.tableData[i].restriction_ids[y];
							for (let z = 0; z < this.masRestrictions.options.length; z++) {
								const ro = this.masRestrictions.options[z];
								if(ro.value == element){
									this.tableData[i].restriction_names.push(ro.label);
								}
							}
						}
					}
					*/
					if(this.tableData[i].external_fio == '') this.tableData[i].external_fio = null;
					if(this.tableData[i].phone == '') this.tableData[i].phone = null;
					this.tableData[i].telegram=this.tableData[i].telegram==true?1:0;
					this.tableData[i].whatsapp=this.tableData[i].whatsapp==true?1:0;
					if(this.tableData[i].email == '') this.tableData[i].email = null;
					if(this.tableData[i].site == '') this.tableData[i].site = null;
					if(this.tableData[i].agregator_id != null){
						for (let z = 0; z < this.masAgrOpts.length; z++) {
							const ro = this.masAgrOpts[z];
							if(ro.value == this.tableData[i].agregator_id){
								this.tableData[i].agregator_name = ro.label;
							}
						}
					}
				}
				//console.log(this.tableData);
				this.$GVO.ApiCall('UpdMyDevExtraData',{obj:'DEV' ,flt:{},uData:{masAllData:this.tableData}})
				.then((objApi) => {
					if(objApi.success === true){
						this.successMsg = true;						
					}else{
						alert('Не сохранилось');
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});
			}
		},
		mounted() {
			this.GetData();
		},
	};
</script>

<style>
/*============================ SEND NOTES ========================================*/
.postAddForm-hide {
	display: none;
}
.postAddForm-show {
	display: block;
	margin-top: 15px;
}
.postForm {
	border: 1px solid transparent;
	border: 1px solid #01B0E0;
	border-radius: 0.2857rem;
	position: sticky;
	bottom: 0;		
}
.postForClick {cursor: pointer;}
.postForm >>> .card-body {padding: 0px 5px 15px 10px!important;}
.cancel-note-btn {position: absolute;  top: 0; right: 0;}
.clientPage .card-collapse .postForm {
	background: #27293d;
}
.white-content .card:not(.card-white) .postForm {
	background: #fff;
}
.postForm:hover, .focus-shadow  {
	box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.postForm h5 {
	margin-bottom: 0px;
}
.form-container {display: flex; flex-direction: column; justify-content: space-between; padding: 0px 5px;}
.postForm .bottom_part, .top_part  {display: flex; flex-wrap: wrap; justify-content: space-between;}
.postForm .bottom_part button, .fileinput {margin: 10px 10px 0px 0px;}

.postAddForm >>> .nav-pills .nav-item i {line-height: 30px;}
.postAddForm >>> .nav-pills .nav-item .nav-link {padding: 7px 20px; min-width: 80px;}
.postAddForm >>> .tab-space {padding: 20px 0 10px 0px;}
.upload-file {display: flex; align-items: center;}
.upload-file h5 {margin-bottom: 0px; margin-right: 10px;}

.note-btn-group {position: relative;}
.note-btn-row {position: absolute; top: 5px; right: 0;}


.success-msg {
	display: flex; justify-content: center;
	opacity: 0;
	animation: success-msg 3s;
  	animation-delay: 0.5s;
}
.success-msg  h6 {color: #00BF9A !important;}

.Curator-outer-editor .el-table table > thead > tr > th {vertical-align: top;}

@keyframes success-msg {
  from {opacity: 0;}
  to {opacity: 100%;}
}

/*===media===============================*/
@media (max-width: 768px) {	
	
}



</style>
